import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import Integrasi from '../componen/integrasi/Integrasi';

export const IntegrasiPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
      <Integrasi />
    </Layout>
  );
};
